const type = {
  RADIO: 'radio', // 单选题
  MULTIPLE_RADIO: 'multipleRadio',// 多选题
  ANSWER: 'answer', // 回答题
  RATE: 'rate',// 评分
  NUMBER: 'number', // 数字
  ADDRESS: 'address', // 地址
  HELP_TEXT: 'helpText', // 说明文字
  DATE: 'date', // 日期
};

export { type };
